import { render } from "./RecentNews.vue?vue&type=template&id=13e0b5aa&scoped=true"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"

import "./RecentNews.vue?vue&type=style&index=0&id=13e0b5aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e0b5aa"]])

export default __exports__